<template>
	<div>
		<div v-if="loading" class="background">
			<div v-if="loading" class="text-center lds-circle">
				<div><img src="@/assets/img/logo.png" /></div>
			</div>
		</div>
		<div v-if="application.applicationStatus === ApplicationStatus.OFFERREJECTED">
			<h3 class="text-center bold" style="margin-top: 50px">You have rejected the offer for this job.</h3>
		</div>
		<div v-else-if="application.applicationStatus === ApplicationStatus.OFFERACCEPTED">
			<h3 class="text-center bold" style="margin-top: 50px">Congratulations! You have accepted the offer for this job.</h3>
		</div>
		<div v-else-if="application.applicationStatus === ApplicationStatus.OFFERSENT">
			<md-card>
				<div class="offer-header">
					<div class="offer-info">
						<md-icon> domain </md-icon>
						<h4 class="offer-details-heading">Company Name</h4>
					</div>
					<p class="offer-text">{{ job.companyName }}</p>
				</div>

				<md-divider></md-divider>

				<div class="w-full flex items-center justify-between" style="flex-wrap: wrap">
					<div class="offer-header">
						<div class="offer-info">
							<md-icon> place </md-icon>
							<h4 class="offer-details-heading">Location</h4>
						</div>
						<p class="offer-text">{{ micro === null ? 'No Location' : micro.location }}</p>
					</div>
					<div class="offer-header">
						<div class="offer-info">
							<md-icon> work </md-icon>
							<h4 class="offer-details-heading">Job Type</h4>
						</div>
						<p class="offer-text">{{ job.jobType }}</p>
					</div>
					<div class="offer-header">
						<div class="offer-info">
							<md-icon> paid </md-icon>
							<h4 class="offer-details-heading">Salary</h4>
						</div>
						<p class="offer-text">{{ job && job.offer && job.offer.monthlySalary ? job.offer.monthlySalary : '' }}</p>
					</div>
					<div class="offer-header">
						<div class="offer-info">
							<md-icon> event </md-icon>
							<h4 class="offer-details-heading">Start Date</h4>
						</div>
						<p class="offer-text">{{ job && job.offer && job.offer.startDate ? job.offer.startDate : '' }}</p>
					</div>
				</div>

				<div class="centre" style="text-align: right; margin-right: 30px; margin-bottom: 30px">
					<md-button style="margin-right: 2rem" class="md-success" @click="acceptOfferModal = true"> Accept Offer </md-button>
					<md-button class="md-danger" @click="rejectOfferModal = true"> Reject Offer </md-button>
				</div>
			</md-card>
			<modal v-if="acceptOfferModal">
				<template #header>
					<h4 class="modal-title">Accept Job Offer 🥳</h4>
				</template>
				<template #body>
					<p v-if="!offerAccepted" class="modal-description">You are about to accept the job offer from {{ job.companyName }} for the postion: {{ job.name }}</p>
					<p v-if="offerAccepted" class="modal-description">Congratulations on accepting the job offer!</p>
				</template>
				<template #footer>
					<div v-if="!offerAccepted">
						<md-button class="md-danger" style="margin-right: 1rem" @click="acceptOfferModal = false">Cancel</md-button>
						<md-button class="md-success" @click="acceptJobOffer">Accept</md-button>
					</div>
					<div v-if="offerAccepted">
						<md-button class="md-success" @click="confirmAcceptedOffer()">Ok</md-button>
					</div>
				</template>
			</modal>

			<modal v-if="rejectOfferModal">
				<template #header>
					<h4 v-if="!rejectedOfferConfirmation" class="modal-title">Whoa there! 🤚</h4>
					<h4 v-if="rejectedOfferConfirmation">Offer Rejection</h4>
				</template>
				<template #body>
					<p v-if="!rejectedOfferConfirmation" class="modal-description">
						You are about to reject the job offer from {{ job.companyName }} for the postion: {{ job.name }}
					</p>
					<p v-if="rejectedOfferConfirmation" class="modal-description">Thank you for your reponse. We will be in touch with the employer's response.</p>
				</template>
				<template #footer>
					<div v-if="!rejectedOfferConfirmation">
						<md-button class="md-danger" style="margin-right: 1rem" @click="rejectOfferModal = false">Cancel</md-button>
						<md-button class="md-success" @click="rejectJobOffer">Reject</md-button>
					</div>
					<div v-if="rejectedOfferConfirmation">
						<md-button class="md-success" @click="confirmRejection()">Ok</md-button>
					</div>
				</template>
			</modal>

			<modal v-if="rejectOfferReasonModal">
				<template slot="header">
					<div style="display: flex; flex-direction: column">
						<h4 class="modal-title black">Please specify the reasons for rejecting the offer</h4>
						<p v-if="validationMessage !== ''" style="color: red" class="text-center">{{ this.validationMessage }}</p>
						<md-button class="md-simple md-just-icon md-round modal-default-button" @click="closeRejectOfferReasonModal">
							<md-icon>clear</md-icon>
						</md-button>
					</div>
				</template>

				<template slot="body">
					<md-table :value="rejectionReasons" md-card @md-selected="onSelect">
						<md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="multiple">
							<md-table-cell md-label="Reasons"> {{ item.reason }}</md-table-cell>
						</md-table-row>
					</md-table>
				</template>

				<template slot="footer">
					<div class="centre" style="text-align: center">
						<md-button class="md-button md-danger" @click="closeRejectOfferReasonModal"> Cancel</md-button>
						&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						<md-button class="md-button md-success" @click="confirmDeclineModal"> Confirm</md-button>
					</div>
				</template>
			</modal>

			<modal v-if="emailError">
				<template slot="header">
					<div style="display: flex; flex-direction: column">
						<h4 class="modal-title black">Whoops!😟</h4>
						<md-button class="md-simple md-just-icon md-round modal-default-button" @click="emailError = false">
							<md-icon>clear</md-icon>
						</md-button>
					</div>
				</template>

				<template slot="body">
					<p>An error occured, please refresh the page and try again or contact our Customer Success Team</p>
				</template>

				<template slot="footer">
					<div class="centre" style="text-align: center">
						<md-button class="md-button md-success" @click="emailError = false"> Ok</md-button>
					</div>
				</template>
			</modal>
		</div>
		<div v-else>
			<h3 class="text-center bold" style="margin-top: 50px">You have no offer for this job yet.</h3>
		</div>
	</div>
</template>
<script>
import Modal from '@/components/Modal';
import { OfferRejectionReasons } from '@/constants/offerRejectionReasons';
import firebase from 'firebase/compat/app';
import db from '@/firebase/init';
import { ApplicationStatus } from '@/constants/application-status.js';
export default {
	data() {
		return {
			acceptOfferModal: false,
			emailError: false,
			offerAccepted: false,
			rejectOfferModal: false,
			offerRejected: false,
			rejectOfferReasonModal: false,
			rejectionReasons: OfferRejectionReasons,
			selectedDeclineReasons: [],
			validationMessage: '',
			ApplicationStatus,
			rejectedOfferConfirmation: false,
			loading: false,
			jobOffer: this.job.offer,
		};
	},
	components: { Modal },
	props: {
		job: { type: Object },
		micro: { type: Object },
		application: { type: Object },
		user: { type: Object },
	},
	methods: {
		formatBudget(micro) {
			if (micro === null) {
				return;
			}
			let budget = '';
			if (micro?.budget?.min || micro?.budget?.max) {
				let { min, max } = micro.budget;
				budget = 'R' + min + ' ' + '-' + ' ' + 'R' + max;
				return budget;
			} else {
				budget = 'R' + micro.budget;
				return budget;
			}
		},
		async acceptJobOffer() {
			try {
				this.loading = true;
				const result = await this.sendAcceptOffer(
					this.job.clientName,
					this.job.email,
					this.job.companyName,
					this.job.jobType,
					this.job.jobId,
					this.job.phone,
					this.application.applicant,
					this.application.applicantEmail,
					this.job.name
				);

				if (result && result.data.Ok) {
					this.offerAccepted = true;
					const applicant = await db.collection('applications').doc(this.application.id);
					applicant.update({
						applicationStatus: ApplicationStatus.OFFERACCEPTED,
						status: ApplicationStatus.OFFERACCEPTED,
					});
					this.loading = false;
				} else {
					this.emailError = true;
					this.acceptOfferModal = false;
					this.loading = false;
				}
			} catch (error) {
				console.error('Error sending acceptance email or updating database:', error);
				this.loading = false;
			}
		},
		rejectJobOffer() {
			this.rejectOfferReasonModal = true;
			this.rejectOfferModal = false;
		},
		async confirmDeclineModal() {
			if (this.selectedDeclineReasons.length === 0) {
				this.validationMessage = 'Please select at least one reason';
				return;
			}

			try {
				this.loading = true;
				this.rejectOfferReasonModal = false;
				let declineReasonList = this.selectedDeclineReasons.map(x => x.reason);

				const result = await this.sendReject(declineReasonList, this.job.clientName, this.job.email, this.application.applicant, this.job.name);

				if (result && result.data.Ok) {
					const applicant = await db.collection('applications').doc(this.application.id);
					applicant.update({
						applicationStatus: ApplicationStatus.OFFERREJECTED,
						status: ApplicationStatus.OFFERREJECTED,
						interviewRequestSent: true,
					});

					this.rejectedOfferConfirmation = true;
					this.rejectOfferModal = true;
					this.loading = false;
				} else {
					this.emailError = true;
					this.rejectOfferReasonModal = false;
					this.loading = false;
				}
			} catch (error) {
				console.error('Error sending rejection or updating database:', error);
			}
		},
		confirmRejection() {
			this.rejectOfferModal = false;
			window.location.reload();
		},
		confirmAcceptedOffer() {
			this.acceptOfferModal = false;
			window.location.reload();
		},
		onSelect(items) {
			this.selectedDeclineReasons = items;
		},
		closeRejectOfferReasonModal() {
			this.validationMessage = '';
			this.rejectOfferReasonModal = false;
		},
		async sendAcceptOffer(employerName, employerEmail, companyName, jobType, jobId, employerPhone, studentName, studentEmail, jobName) {
			const sendEmployeerandStudentAcceptOffer = firebase.functions().httpsCallable('sendStudentAcceptsJob');
			try {
				const params = {
					employerName,
					employerEmail,
					companyName,
					jobType,
					jobId,
					employerPhone,
					studentName,
					studentEmail,
					jobName,
				};
				const response = await sendEmployeerandStudentAcceptOffer(params);
				return response;
			} catch (e) {
				console.log({ e });
			}
		},
		async sendReject(selectedDeclineReasons, employerName, employerEmail, studentName, jobTitle) {
			const sendRejection = firebase.functions().httpsCallable('sendStudentRejectsJob');
			try {
				const params = {
					selectedDeclineReasons,
					employerName,
					employerEmail,
					studentName,
					jobTitle,
				};

				const response = await sendRejection(params);
				return response;
			} catch (e) {
				console.log({ e });
			}
		},
	},
};
</script>
<style lang="scss" scoped>
.modal-description {
	margin-top: 1rem !important;
}
.offer-header {
	flex-direction: column;
	margin-bottom: 40px;
	margin-left: 40px;
	margin-right: 40px;
}
.offer-info {
	display: flex;
	align-items: center;
	width: fit-content;
}
.offer-details-heading {
	margin-left: 0.5rem;
}

.offer-text {
	font-size: 17px;
	margin-top: -1rem;
}
.background {
	width: 100vw !important;
	height: 100vh !important;
	display: flex !important;
	align-items: center !important;
	justify-content: center !important;
}
.md-table-head-container {
	height: 28px;
	padding: 0;
	text-align: center !important;
}
.md-table-head {
	padding: 12px 8px;
	text-align: center !important;
}
</style>
